import { render } from "./MetricSettings.vue?vue&type=template&id=822c3fca&scoped=true"
import script from "./MetricSettings.vue?vue&type=script&lang=js"
export * from "./MetricSettings.vue?vue&type=script&lang=js"

import "./MetricSettings.vue?vue&type=style&index=0&id=822c3fca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-822c3fca"]])

export default __exports__